import Layout from "../views/layout";
import Account from "../views/account";
import Activity from "../views/activity/Activity";
import MakeSure from "../views/makeSure/MakeSure";

const envr = process.env.PUBLIC_URL;
export default [
  {
    path: `/dashboard`,
    component: Layout,
    role: "Administrator",
  },
  {
    path: `/resources`,
    component: Layout,
    role: "Administrator",
  },
  {
    path: `/roles`,
    component: Layout,
    role: "Administrator",
  },
  {
    path: `/admin/tags`,
    component: Layout,
    role: "Administrator",
  },
  // {
  //   path: `/shifts`,
  //   component: Layout,
  //   role: "Administrator",
  // },
  {
    path: `/clients/:id/overview`,
    component: Layout,
    role: "Administrator",
  },
  {
    path: `/clients`,
    component: Layout,
    role: "Administrator",
  },
  {
    path: `/archived-clients`,
    component: Layout,
    role: "Administrator",
  },
  {
    path: `/projects/:id/overview`,
    component: Layout,
    role: "Administrator",
  },
  {
    path: `/projects`,
    component: Layout,
    role: "Administrator",
  },
  {
    path: `/scopeItems`,
    component: Layout,
    role: "Administrator",
  },
  {
    path: `/changeRequests`,
    component: Layout,
    role: "Administrator",
  },
  {
    path: `/risks`,
    component: Layout,
    role: "Administrator",
  },
  {
    path: `/communications`,
    component: Layout,
    role: "Administrator",
  },
  {
    path: `/budgets`,
    component: Layout,
    role: "Administrator",
  },
  {
    path: `/scopes/:id/overview`,
    component: Layout,
    role: "Administrator",
  },
  {
    path: `/taskgroups/:id/overview`,
    component: Layout,
    role: "Administrator",
  },
  {
    path: `/meeting`,
    component: Layout,
    role: "Administrator",
  },
  {
    path: `/meetings-registry`,
    component: Layout,
    role: "Administrator",
  },
  {
    path: `/portfolio/:id/overview`,
    component: Layout,
    role: "Administrator",
  },
  {
    path: `/portfolio`,
    component: Layout,
    role: "Administrator",
  },
  {
    path: `/program/:id/overview`,
    component: Layout,
    role: "Administrator",
  },
  {
    path: `/program`,
    component: Layout,
    role: "Administrator",
  },
  {
    path: `/settings`,
    component: Layout,
    role: "Administrator",
  },
  {
    path: `/account`,
    component: Account,
    role: "Administrator",
  },
  {
    path: `/resource-planner`,
    component: Layout,
    role: "Administrator",
  },
  {
    path: `/timesheet`,
    component: Layout,
    role: "Administrator",
  },
  {
    path: `/resource-reports`,
    component: Layout,
    role: "Administrator",
  },
  {
    path: `/notifications/activity`,
    component: Activity,
    role: "Administrator",
  },
  {
    path: `/notifications/settings`,
    component: Activity,
    role: "Administrator",
  },
  {
    path: `/reminders/activity`,
    component: Activity,
    role: "Administrator",
  },
  {
    path: `/deletion-request`,
    component: Layout,
    role: "Administrator",
  },
  {
    path: `/make-sure`,
    component: Layout,
    role: "Administrator",
  },
  {
    path: `/ai-create`,
    component: Layout,
    role: "Administrator",
  },
  {
    path: `/runbooks/:id/overview`,
    component: Layout,
    role: "Administrator",
  },
];
